<template>
  <div>
    <breadcrumbs home="Shipment zones" :back="back"/>

    <purtrak-table name="shipmentZones" objectType="shipment zones" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   listEndPoint="shipmentZones"
                   fields="id,name,active"
                   :listFilters="listFilters"
                   :item-class="shipmentZone => (!shipmentZone.active ? 'grey--text ' : '')"
                   @dblclick="shipmentZone => $router.push({name:'ShipmentZonesEdit',params:{shipmentZoneId:shipmentZone.id}})"
                   title="Shipment zones"
                   :print-info="{pageSize:'portrait', subTitle:[]}"
                   download-endpoint="shipmentZonesExportCSV">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.search='';filters.status='1'">
          <v-list-item>
            <filter-search label="Name" v-model="filters.search"/>
          </v-list-item>
          <v-list-item>
            <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{value:'1',text:'Active'},{value:'0',text:'Inactive'}]" v-model="filters.status"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.search" close small class="ml-1" @click:close="filters.search=''">Tax: {{filters.search}}</v-chip>
          <v-chip v-show="filters.status!='1'" close small class="ml-1" @click:close="filters.status='1'">{{filters.status=='0'?'Inactive':'All'}}</v-chip>
        </template>
      </template>
      <template v-slot:menu v-if="!readOnly">
        <v-list-item :to="{name:'ShipmentZonesEdit'}"><v-list-item-title>Create shipment zone</v-list-item-title></v-list-item>
      </template>

      <template v-slot:header.action v-if="!readOnly">
        <v-btn fab color="primary" small :to="{name:'ShipmentZonesEdit'}"><v-icon>mdi-plus</v-icon></v-btn>
      </template>
      <template v-slot:item.action="{item}" v-if="!readOnly">
        <v-btn small icon @click.stop="shipmentZone = item;showDelete = true"><v-icon small>mdi-delete</v-icon></v-btn>
      </template>
      <template v-slot:item.name="{item,value,printing}">
        <template v-if="printing">{{value}}</template>
        <template v-else>
          <v-hover v-if="!readOnly" v-slot="{hover}">
            <a @click.stop="$router.push({name:'ShipmentZonesEdit',params:{shipmentZoneId:item.id}})"
                :class="{'text-decoration-underline':hover,'grey--text':!item.active}">{{item.name}}</a>
          </v-hover>
          <div v-else :class="{'grey--text':!item.active}">{{item.name}}</div>
          <div v-if="!item.active" class="grey--text text-caption">Inactive</div>
        </template>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="shipmentZone.name" @delete="performDelete"/>
  </div>
</template>

<script>

export default {
  name: 'ShipmentZones',
  props: {
    back: {type:Array, required:false}
  },
  data() {
    return {
      filters: {
        status: '1',
        search: ''
      },
      shipmentZone: {},
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true}],
      headers: [{ text: 'NAME', value: 'name', width:'70%',sortable:true},
                { text: '' , value:'action', width:'5%', sortable:false,align:'center'}]
    }
  },
  computed: {
    readOnly() {
      return !this.$store.getters.company.permissions.includes('selling.write');
    },
    listFilters() {
      const filters = [];
      if (this.filters.search)
        filters.push({field:'name', comparator:'contains', value:this.filters.search});
      if (this.filters.status != '2')
        filters.push({field:'active', comparator:'eq', value:this.filters.status === '1' ? 'true' : 'false'});
      return filters;
    }
  },
  methods: {
    async performDelete() {
      this.loading = true;
      const results = await this.$apiCall(`mutation ShipmentZones($id:ID!) {
                                                objectDelete(id:$id)
                                              }`,
                                          {id:this.shipmentZone.id});
      this.loading = false;
      if (!results.error) {
        this.$store.commit('setError', {type:'success',message:`Deleted shipment zone`});
        this.$refs.table?.buildList();
      }
    },
  }
}
</script>